<template>
  <div id="app">
    <div id="nav">
    </div>
    <router-view/>
  </div>
</template>
<script>
export default {
  name: 'App',
  created() {
    window.location.replace('https://ail-canada.org/');
    // window.open('https://www.w3schools.com');
  },
  mounted() {
    // window.open('https://www.w3schools.com');
    window.location.replace('https://ail-canada.org/');
  },
};
</script>
<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

#nav {
  padding: 30px;
}

#nav a {
  font-weight: bold;
  color: #2c3e50;
}

#nav a.router-link-exact-active {
  color: #42b983;
}
</style>
